/**
 * Writes to localStorage without throwing on quota / failures.
 * When the key itself is too large, removes any existing value for that key
 */
export function safeLocalStorageSetItem(key: string, value: string): boolean {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (error: unknown) {
    const isQuotaError =
      error instanceof DOMException &&
      (error.name === 'QuotaExceededError' ||
        error.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
        error.code === 22);

    if (isQuotaError) {
      try {
        window.localStorage.removeItem(key);
        window.localStorage.setItem(key, value);
        return true;
      } catch (retryError: unknown) {
        console.warn('localStorage quota exceeded; could not persist', key, retryError);
        return false;
      }
    }

    console.warn('localStorage setItem failed', key, error);
    return false;
  }
}
